module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/star1.a7dfb93c.png";